<template>
    <ul class="uk-list uk-list-divider">
    <p class="uk-text-center"><span v-if="message" class="uk-text-small uk-text-light" :class="message.type">{{message.text}}</span></p>
      <li v-for="(pass, idx) in completed" :key="pass.id">
          <div class="" uk-grid>
            <div class="uk-width-5-6@m">
                <h4>Attempt {{Math.trunc(idx / 2 + 1)}}. {{pass.title}}</h4>
                <p class="s-name">{{pass.description}}</p>
            </div>
            <div class="uk-width-1-6@m uk-align-center">
                <a href="" class="uk-icon-button uk-button-primary uk-margin-small-right" uk-icon="check" uk-tooltip="See result" @click.prevent="seeCompleted(pass.id)"></a>
                <a href="" class="uk-icon-button uk-button-primary" uk-icon="trash" uk-tooltip="Delete result" @click.prevent="deleteCompleted(pass.id)" v-if="isAdmin || isManager"></a>
            </div>
        </div>
      </li>
      <li v-if="!completed.length > 0">
        <div class="uk-placeholder uk-text-center" style="color: #8a959b; line-height: 22px;">
            No completed assessments available.<br/><br/>
        </div>
        </li>
    </ul>
</template>

<script>
import CompletedService from '@/services/completed.service';
export default {
    name: 'ListCompletedAssessmets',
    data() {
        return {
            completed: [],
            message: ''
        }
    },
    mounted() {
        this.getCompleted();
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManager() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('manager');
            }
            return false;
        },
        isAdmin() {
           if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('admin');
            }
            return false;
        },
    },
    created() {
        setInterval(() => {
            this.message = null;
        }, 10000)
    },
    methods: {
        getCompleted() {
            CompletedService.all().then(
            res => {
                this.completed = res.data.completed;
            },
            error => {
                let message = (error.response && error.response.data.message.message) || error.message || error.toString();
                this.message = {text: message, type: 'uk-text-danger'}
            }
            )
        },
        seeCompleted(id) {
             this.$router.push({ name: 'assessment.completed', params: { id: id } });
        },
        deleteCompleted(id){
            CompletedService.delete(id).then(
            res => {
              this.completed = res.data.completed;
              this.message = {text: res.data.message, type: 'uk-text-success'}
            },
            error => {
              let message = (error.response && error.response.data.message.message) || error.message || error.toString();
              this.message = {text: message, type: 'uk-text-danger'}
            }
          ) 
        }
    },
}
</script>

<style>

</style>